module.exports = __webpack_public_path__ + "img/logo.42d54b71.png";